import React, { useState } from 'react';
import Button from '@mui/material/Button';  // Import Material-UI Button
 
const ApiButtonPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
 
  // Function to call the API when the button is clicked
  const handleClick = async () => {
    setLoading(true);
    setError('');
    setMessage('');
 
    try {
      // Send a POST request to the API using fetch
      const response = await fetch('http://localhost:8086/api/insert-data', {
        method: 'POST',
      });
 
      // Check if the response status is OK (200)
      if (!response.ok) {
        throw new Error('Failed to insert data');
      }
 
      // Check the content type of the response
      const contentType = response.headers.get("Content-Type");
 
      // If the response is JSON, parse it as JSON
      if (contentType && contentType.includes("application/json")) {
        const data = await response.json();
        setMessage(data.message || 'Data inserted successfully!');
      } else {
        // If the response is not JSON, handle it as plain text
        const textData = await response.text();
        setMessage(textData); // Show the plain text response
      }
    } catch (err) {
      console.error('Error calling the API:', err);
      setError('Error occurred while calling the API');
    } finally {
      setLoading(false);
    }
  };
 
  return (
    <div>
      {/* <h1>Call API with Button Click</h1> */}
      <Button
        onClick={handleClick}
        disabled={loading}
        variant="contained"
        color="error"  // Set the button color to red (Material-UI predefined color)
        sx={{ marginTop: 4,marginLeft:"40px" }}  // Optional: add some margin if needed
      >
        {loading ? 'Loading...' : 'Insert B1 and B2'}
      </Button>
   
 
      {/* Show the response message or error */}
      {message && <p style={{ color: 'green' }}>{message}</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
    </div>
  );
};
 
export default ApiButtonPage;